<script>
	let btn = {
		copy: { text: 'Kopieer email signature', class: 'btn done' },
		code: { text: 'Kopieer html code', class: 'btn done' },
		dark: { text: 'Bekijk donkere modus', enabled: false }
	}

	import Signature from './Signature.svelte'
	//import SignatureDark from './Signature_dark.svelte';

	const companyData = {
		addresses: [
			{ location: 0, line1: 'Moermanskkade 305', line2: '1013 BC Amsterdam' },
			{ location: 1, line1: 'Nieuwe Uitleg 25', line2: '2514 BR Den Haag' }
		]
	}

	const persData = {
		naam: 'Frans de Wit',
		jobtitle: 'Animator',
		telefoon: '020 204 4535',
		extraInfo: 'Niet aanwezig op woensdag',
		email: 'voornaam.achternaam@clarify.nl',
		location: 0,
		adres_line1: 'Moermanskkade 305',
		adres_line2: '1013 BC Amsterdam',
		bannerLink: 'https://clarify.nl/email-signature?v=2024-03',
		instagramLink: 'https://www.instagram.com/clarifynl/',
		vimeoLink: 'https://vimeo.com/clarifynl',
		//legaltext : 'Dit bericht is slechts bestemd voor de geadresseerde en kan informatie bevatten die persoonlijk en/of vertrouwelijk is en die niet openbaar mag worden gemaakt. Indien u niet zelf de geadresseerde bent, wordt u erop gewezen dat verdere verspreiding, openbaarmaking of vermenigvuldiging van dit bericht verboden is. Indien u dit bericht per vergissing hebt ontvangen, verzoek ik u mij zo snel mogelijk op de hoogte te stellen en het originele bericht en eventuele kopieën ervan, te verwijderen. Dank voor uw medewerking.',
		legaltext: '',
		email_generated: '',
		linkedinLink: ''
	}

	//

	const colorData = {
		id: 'signature-clarify',
		fontColorDark: '#444444',
		fontColorGray: 'gray',
		fontColorBlack: 'black',
		fontColorSilver: 'silver',
		colorOrange: '#fd4024',
		backgroundColor: 'white'
	}

	const colorDataDark = {
		id: 'signatureDark',
		fontColorDark: 'rgb(191, 191, 191) ',
		fontColorGray: 'rgb(139, 139, 139)',
		fontColorBlack: 'white',
		fontColorSilver: 'rgb(91, 91, 91)',
		colorOrange: '#fd4024',
		backgroundColor: 'rgb(51, 51, 51)'
	}

	let colors = colorData

	function generateEmail() {
		console.log(persData.naam)
		//	persData.linkedinLink = "https://www.linkedin.com/in/" + persData.naam.toLowerCase().replaceAll(" ", "");
		persData.email_generated =
			persData.naam.replace(/ /, '.').replaceAll(' ', '').toLowerCase() + '@clarify.nl'
		persData.email = persData.email_generated
	}
	generateEmail()

	function showHTMLcode() {
		document.getElementById('code-preview').innerHTML =
			document.getElementById('signature-clarify').innerHTML
		document.getElementById('code-preview').classList.add('show')
		navigator.clipboard.writeText(document.getElementById('signature-clarify').innerHTML)

		btn.code.text = 'Gekopieerd naar clipboard!'
		btn.code.done = true

		setTimeout(() => {
			btn.code.done = false
			btn.code.text = 'Kopieer html code'
		}, 2000)
	}

	function showDarkView() {
		//persData.backgroundColor = "rgb(51, 51, 51)";
		btn.dark.enabled ^= true
		btn.dark.enabled
			? (btn.dark.text = 'Bekijk lichte modus')
			: (btn.dark.text = 'Bekijk donkere modus')

		btn.dark.enabled ? (colors = colorDataDark) : (colors = colorData)
	}

	function CopyToClipboard() {
		var doc = document,
			text = doc.getElementById('signature-clarify'),
			range,
			selection

		if (doc.body.createTextRange) {
			range = doc.body.createTextRange()
			range.moveToElementText(text)
			range.select()
		} else if (window.getSelection) {
			selection = window.getSelection()
			range = doc.createRange()
			range.selectNodeContents(text)
			selection.removeAllRanges()
			selection.addRange(range)
		}

		document.execCommand('copy')

		window.getSelection().removeAllRanges()
		btn.copy.text = 'Gekopieerd naar clipboard!'
		btn.copy.done = true

		setTimeout(() => {
			btn.copy.done = false
			btn.copy.text = 'Kopieer email signature'
		}, 2000)
	}
</script>

<div id="app">
	<div class="header">
		<h1>Clarify email signature generator</h1>
	</div>	
<div id="wrapper">

	<main id="signature-wrapper">
		<div class:enabled={true}>
			<div class:light={!btn.dark.enabled} class:dark={btn.dark.enabled}>
				<div class="faketext">
					Beste Lorem,<br />
					<br />
					Ipsum dolor sit amet, consectetur adipiscing elit. Phasellus eleifend dolor at varius
					venenatis. Aliquam ut orci mollis, condimentum est nec, lobortis velit. In hac habitasse
					platea dictumst. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
					posuere cubilia curae; Curabitur a lectus auctor, iaculis nisi ac, consequat justo.
				</div>
				<Signature {...companyData} {...persData} {...colors} />
			</div>
		</div>

		
	</main>

	<aside class="inputWrapper">
		<div>
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label aria-label="naam">Voornaam Achternaam</label>
			<input
				bind:value={persData.naam}
				on:change={generateEmail}
				placeholder="Voornaam Achternaam"
			/>
		</div>
		<span class="input_note"> </span>

		<div>
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Functie</label>
			<input bind:value={persData.jobtitle}  placeholder="Functie" />
		</div>
		<span class="input_note">
			Medior of Senior eventueel toevoegen, junior svp niet vernoemen.</span
		>
		<div>
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Persoonlijke melding</label>
			<input bind:value={persData.extraInfo} placeholder="Persoonlijke melding" />
		</div>
		<span class="input_note"> Dit veld is optioneel. <br />Hou het graag kort en bondig.</span>

		<div>
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Telefoonnummer</label>
			<input bind:value={persData.telefoon} placeholder="Telefoonnummer"/>
		</div>
		<span class="input_note"
			>Invullen zonder +31 en spaties als volgt:<br /> 020 204 4535 of 06 1234 5667</span
		>

		<div>
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Email</label>
			<input
				class={persData.email == persData.email_generated ? 'generated' : 'altered'}
				bind:value={persData.email}
			/>
		</div>
		<span class="input_note"
			>Het e-mailadres wordt automatisch gegenereerd op basis van je naam, maar kan in overleg
			aangepast worden.</span
		>

		<div>
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Adres</label>
			<select bind:value={persData.location}>
				<option value={0}>Amsterdam</option>
				<option value={1}>Den Haag</option>
			</select>
		</div>
		<span class="input_note"> </span>

		<div class="buttons">
			<button class="btn copy {btn.copy.done ? 'done' : ''}" on:click={CopyToClipboard}>
				{btn.copy.text}
			</button>
			<button class="btn code {btn.code.done ? 'done' : ''}" on:click={showHTMLcode}>
				{btn.code.text}
			</button>
			<button class="btn darkmodus {btn.dark.enabled ? 'done' : ''}" on:click={showDarkView}>
				{btn.dark.text}
			</button>
		</div>
	</aside>
</div>
</div>

<div class="codePreview">
	<textarea id="code-preview" onclick="this.focus();this.select()" readonly="readonly"></textarea>
</div>

<style>
#app {
	max-width: 1440px;
	margin: 0 auto;
}

	aside {
		display: grid;
		grid-template-columns: 250px auto;
		grid-auto-rows: max-content;
		grid-gap: 20px;
	}

	label {
		display: none;
		font-style: italic;
		font-size: 12px;
		line-height: 25px;
	}

	input,
	select {
		display: inline-block;
		margin-bottom: 0;
		width: 250px;
	}

	input.generated {
		color: gray;
		font-style: italic;
	}

	input.altered {
		color: black;
	}

	.input_note {
		text-align: left;
		font-size: 10px;
		color: #888;
		font-style: italic;
		text-wrap: balance;
	}

	.faketext {
	    font-family: Arial;
	    font-size: 16px;
	    line-height: 22px;
	    padding-bottom: 0px;
	    opacity: 0.2;
	    font-weight: 300;
	    max-width: 600px;
	}
	.codePreview {
		display: none;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		color: white;
		z-index: 9999;
		padding: 20px;
		overflow-y: auto;
	}
</style>
